module.exports = __webpack_public_path__ + "images/file_icons_v2/wps-8e67959f3d744064a544f8898ea9ee58.svg";